module.exports = __webpack_public_path__ + "img/surfing.e8afe239.svg";